import {Observable}                        from 'rxjs';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';

import Volume from '../../../State/Stores/Volume/Volume';

const createForceMutedStream = (
    volumeUpdate$: Observable<Volume>
): Observable<void> =>
    volumeUpdate$
        .pipe(
            map(volume => volume.isForceMuted),
            distinctUntilChanged(),
            filter(Boolean)
        );

export default createForceMutedStream;